export default __webpack_public_path__ + "static/media/Aura-Egg__56.fae58954.png";